import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';

export type PortalOverlayHeaderIconBtnProps = {
  onPress: () => void;
  testID?: string;
  size?: number; // TODO Check if we should push back on the change to 16x16 in Figma
  noPadding?: boolean; // Integrated padding is evil
  color?: string;
  Icon: React.ElementType<{ width: number, height: number, color: string }>;
  position: 'left' | 'right';
  iconTestID?: string;
};

export default function PortalOverlayHeaderIconBtn({
  size = 20,
  onPress,
  testID,
  noPadding = false,
  color = BrandColor.BackInBlack,
  Icon,
  position,
  iconTestID,
}: PortalOverlayHeaderIconBtnProps) {
  const paddingLeft = position === 'right' ? 4 : 8;
  const paddingRight = position === 'right' ? 8 : 4;

  return (
    <TouchableOpacity
      style={{
        display: 'flex',
        height: '100%',
      }}
      onPress={e => {
        e.preventDefault();
        onPress();
      }}
      accessibilityRole="button"
      testID={testID}
    >
      <Box
        flexGrow={1}
        alignItems="center"
        justifyContent="center"
      >
        <Box
          paddingLeft={noPadding ? 0 : paddingLeft}
          paddingRight={noPadding ? 0 : paddingRight}
          testID={iconTestID}
        >
          <Icon width={size} height={size} color={color} />
        </Box>
      </Box>
    </TouchableOpacity>
  );
}
